import { UserType } from '../../entities';
import { AppSecurityRight, MobileTechniciansSecurityRight, PortalContractorSecurityRight } from '../modules';
import { SecurityRole, SecurityRoleType } from '../security.role';

export class SubcontractorUser implements SecurityRole {

    _id = 'b040e1b4-20f6-4083-b0c2-0f043ae7cc17';
    system = true;
    hidden = false;
    type = UserType.Subcontractor;
    name = SecurityRoleType.SubcontractorUser;
    description = 'Can use the mobile app to update progress of jobs. These users work for 3rd party subcontractors.';
    rights = [
        AppSecurityRight.LoginContractor,
        AppSecurityRight.LoginField,
        MobileTechniciansSecurityRight.CanAccessJobs,
        PortalContractorSecurityRight.CanAccessJobs,
        PortalContractorSecurityRight.ManageCompliance,
        PortalContractorSecurityRight.CanKnowledgeBase,
        MobileTechniciansSecurityRight.CanAccessTimesheets,
        MobileTechniciansSecurityRight.AllowEditBeforeCheckIn,
    ];

}

